<div class="energy-calculation-reports">
    <ev-grid-table [gridModel]="displayTemplate">
        <ev-th>
            @for(column of headers; track column.name) {
                @if(column?.isSortable) {
                    <ev-td
                    [area]="column.prop"
                    (click)="updateSort(column.prop)"
                    [isSelectable]="true"
                    [textAlignment]="column.textAlignment ?? 'left'"
                    [selected]="sortConfig().sortOption.prop == column.prop">
                        {{column.name.toUpperCase()}}
                    </ev-td>
                } 
                @else {
                    <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                        {{column.name.toUpperCase()}}
                    </ev-td>
                }
            }
        </ev-th>
        
        @if (tableData()) {
            @for(rowData of tableData(); track rowData.energyCalculationReportID) {
                <ev-tr class="ev-row" [hasRowContent]="false">
                    <ev-td 
                        area="createdDate" 
                        header="Dato" 
                        column
                        title="Dato"
                        [fontBold]="sortConfig().sortOption.prop == 'createdDate'">
                        <div class="column-data">{{rowData.createdDate | date:'dd.MM.yyyy' | defaultconvert}}</div>
                    </ev-td>
                    <ev-td 
                        area="energyCalculationReportID" 
                        header="Rapport Id" 
                        column 
                        title="Rapport Id"
                        [fontBold]="sortConfig().sortOption.prop == 'energyCalculationReportID'">
                        <div class="column-data">{{rowData.energyCalculationReportID}}</div>
                    </ev-td>
                    <ev-td 
                        area="estimatedAnnualEnergyUsePre" 
                        header="Energibruk Pr m² Før tiltak" 
                        column
                        textAlignment="right"
                        title="Energibruk Pr m² Før tiltak"
                        [fontBold]="sortConfig().sortOption.prop == 'estimatedAnnualEnergyUsePre'">
                        <div class="column-data">{{rowData.estimatedAnnualEnergyUsePre / rowData.heatedArea | number : "1.0-0"}} kWh</div>
                    </ev-td>
                    <ev-td 
                        area="estimatedAnnualEnergyUsePost" 
                        header="Energibruk Pr m² Etter tiltak" 
                        column
                        textAlignment="right"
                        title="Energibruk Pr m² Etter tiltak"
                        [fontBold]="sortConfig().sortOption.prop == 'estimatedAnnualEnergyUsePost'">
                        <div class="column-data">{{rowData.estimatedAnnualEnergyUsePost  / rowData.heatedArea | number : "1.0-0"}} kWh</div>
                    </ev-td>
                    <ev-td 
                        area="pdfReportID" 
                        header=""
                        column 
                        title="Se rapport">
                        <div class="column-data">
                            <div class="report" (click)="openReport(rowData.pdfReportID)">
                                @if (downloadingReport) {
                                    <ev-logo-loader variant="dots" width="25px" />
                                } @else {
                                    <div class="document-icon"></div>
                                    <div class="text">Se rapport</div>
                                }
                            </div>
                            
                            @if (hasGreenHomeRole() && rowData.isGreenHome) {
                                <div class="green-home">
                                    <img class="green-home-icon" [src]="greenEnergyIconUrl" alt="Grønn bolig" />
                                    <div class="green-home-text">Grønn bolig</div>
                                </div>
                            }
                        </div>
                    </ev-td>
                </ev-tr>
            }
        }
    </ev-grid-table>

    @if(originalData()?.length > rowsToShow) {
        <div class="show-more-button">
            <button (click)="onShowMore()">Vis flere</button>
        </div>
    }
</div>
